/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import MainLayout from 'components/layouts/main'
import {
  deleteDuplicateFPHistory,
  getBaycFields,
  getDegodsFields,
  getDuplicateMagicEdenSlugs,
  getEthereumTopMovers,
  getMissingHyperspaceSlugsList,
  getOldestLastUpdated,
  getSolanaTopMovers,
  getSpecificFpHistory,
  getTestList,
  setCollectionInactive,
  setCollectionInactiveDuplicateMeSlugs,
} from 'services'
import Button from 'components/commons/button'
import { notifySuccess } from 'components/commons/toast'
import { ToastContainer } from 'react-toastify'

const TestEnvironmentPage = () => {
  const [oldestLastUpdated, setOldestLastUpdated] = useState([])

  const [fpHistory, setFpHistory] = useState([])
  const [duplicateMeSlugs, setDuplicateMeSlugs] = useState<any>([])
  const [listTwo, setListTwo] = useState<any>([])

  const [missingHyperspaceSlugs, setMissingHyperspaceSlugs] = useState<any>([])
  const [testList, setTestList] = useState<any>([])

  const [topSolMoversTweet, setTopSolMoversTweet] = useState('')
  const [topEthMoversTweet, setTopEthMoversTweet] = useState('')

  const [fpList, setFpList] = useState<any>([])

  useEffect(() => {
    getFields()
  }, [])

  const getFields = async () => {
    /* getBaycFields().then((list: any) => {
      setFpList(list)
    })*/

    /* getOldestLastUpdated('solana').then((list: any) => {
      setOldestLastUpdated(list)
    })

    getSolanaTopMovers().then((list: any) => {
      setDuplicateMeSlugs(list)
      setTopMoversTweet('Solana', list)
    })
    getEthereumTopMovers().then((list: any) => {
      setListTwo(list)
      setTopMoversTweet('Ethereum', list)
    }) */
    // return

    getSpecificFpHistory('cryptopunks', 60).then((list: any) => {
      setFpList(list)
    })
    return

    console.log('temp: ')
    const duplicateList: any = []
    getDegodsFields().then((temp1: any) => {
      console.log('temp1: ', temp1)
      for (let i = 0; i < temp1.length; i++) {
        for (let j = 0; j < temp1.length; j++) {
          // 86 vs 172, 75 vs 150
          /* if (temp1[i].price_date == temp1[j].price_date && temp1[i].id != temp1[j].id) {
            duplicateList.push(temp1[j])
          }*/
          /* if ('0' + temp1[i].price_date == temp1[j].price_date && temp1[i].id != temp1[j].id) {
            duplicateList.push(temp1[j])
          }*/
          const splitTemp = temp1[i].price_date.split('/')
          if (
            '0' + splitTemp[0] + '/0' + splitTemp[1] + '/' + splitTemp[2] == temp1[j].price_date &&
            temp1[i].id != temp1[j].id
          ) {
            // duplicateList.push(temp1[i])
            duplicateList.push(temp1[j])
          }
        }
      }
      console.log('duplicateList: ', duplicateList)
      setFpHistory(temp1)
      // deleteDuplicateFPHistory(duplicateList)
    })

    // console.log('temp1: ', temp1)
  }

  const setTopMoversTweet = (chain: string, moversList: any) => {
    let tweetGenerated = 'Top 5 Biggest Movers on ' + chain + ' (in the past 24h):\n'
    for (let index = 0; index < 5; index++) {
      let name = moversList[index].name
      if (moversList[index].twitter_username || moversList[index].solana_twitter_username) {
        name = moversList[index].solana_twitter_username
          ? '@' + moversList[index]?.solana_twitter_username
          : '@' + moversList[index]?.twitter_username
      }
      const i = index + 1
      tweetGenerated +=
        i +
        '. ' +
        name.split('?')[0] +
        ' (' +
        (moversList[index]?.stats?.calculated_percent_change > 0 ? '+' : '') +
        moversList[index]?.stats?.calculated_percent_change?.toFixed(2) +
        '%)' +
        '\n'
    }
    tweetGenerated += '\n' + 'Probably nothing... 🚀 (via @NFTfolioApp)'

    if (chain == 'Solana') {
      setTopSolMoversTweet(tweetGenerated)
    } else {
      setTopEthMoversTweet(tweetGenerated)
    }
  }

  /* const setInactiveDuplicateCollection = async (id: any) => {
    setCollectionInactiveDuplicateMeSlugs(id)
    notifySuccess('Success!')
  } */

  return (
    <React.Fragment>
      <MainLayout style={{ backgroundColor: '#FFFFFF' }}>
        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-4xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Test Environment
          </h1>
          {/* <div style={{ backgroundColor: '#FFFFFF' }}>
            <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
              Oldest Last Updated on Solana
            </h1>

             <div style={{ paddingLeft: 24 }}>
              {oldestLastUpdated.map((doc: any, index: any) => (
                <div
                  key={doc?.id}
                  className='flex flex-row'
                  style={{ alignItems: 'center', marginBottom: 24 }}
                >
                  <div
                    className='flex flex-col'
                    style={{ marginRight: 28, fontWeight: '400', fontSize: 16 }}
                  >
                    <p>#{index + 1}</p>
                  </div>
                  <img src={doc?.image_url} width={60} height={60} style={{ marginRight: 24 }} />

                  <div className='flex flex-col'>
                    <p>
                      {doc.name}
                      {' - '}
                      {doc.last_updated_at
                        ? 'Last Updated At:' + new Date(doc?.last_updated_at * 1000)
                        : 'Last Updated: N/A'}
                    </p>
                    <p>
                      {'Market cap: ' + doc?.stats?.market_cap} {doc.id}
                    </p>
                  </div>
                </div>
              ))}
            </div>
                      </div> */}

          <div style={{ backgroundColor: '#FFFFFF' }}>
            <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
              Fp Data
            </h1>

            <div style={{ paddingLeft: 24 }}>
              {fpList.map((doc: any, index: any) => (
                <div
                  key={doc.id}
                  className='flex flex-row'
                  style={{ alignItems: 'center', marginBottom: 24 }}
                >
                  <div
                    className='flex flex-col'
                    style={{ marginRight: 28, fontWeight: '400', fontSize: 16 }}
                  >
                    <p>
                      {doc?.slug} - Floor price: {doc?.floor_price}
                    </p>
                  </div>

                  <div className='flex flex-col'>
                    <p>Price Date: {doc?.price_date}</p>
                    <p>
                      {'ID: '}
                      {doc.id}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* <div style={{ padding: 24 }}>
            <div style={{ color: '00FFFF', whiteSpace: 'break-spaces', marginBottom: 10 }}>
              {topSolMoversTweet}
            </div>
            <Button
              onClick={() => {
                navigator.clipboard.writeText(topSolMoversTweet)
                notifySuccess('Tweet copied to clipboard')
              }}
              className='bg-blue-500 font-semibold text-white capitalize'
            >
              <p style={{ color: '00FFFF' }}>Copy Tweet</p>
            </Button>
          </div>

          <div style={{ padding: 24 }}>
            <div style={{ color: '00FFFF', whiteSpace: 'break-spaces', marginBottom: 10 }}>
              {topEthMoversTweet}
            </div>
            <Button
              onClick={() => {
                navigator.clipboard.writeText(topEthMoversTweet)
                notifySuccess('Tweet copied to clipboard')
              }}
              className='bg-blue-500 font-semibold text-white capitalize'
            >
              <p style={{ color: '00FFFF' }}>Copy Tweet</p>
            </Button>
          </div>*/}
        </div>

        {/* <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Top 24h Movers by Solana
          </h1>

          <div style={{ paddingLeft: 24 }}>
            {duplicateMeSlugs.map((doc: any, index: any) => (
              <div
                key={doc.id}
                className='flex flex-row'
                style={{ alignItems: 'center', marginBottom: 24 }}
              >
                <div
                  className='flex flex-col'
                  style={{ marginRight: 28, fontWeight: '400', fontSize: 16 }}
                >
                  <p>#{index + 1}</p>
                </div>
                <img src={doc.image_url} width={60} height={60} style={{ marginRight: 24 }} />

                <div className='flex flex-col'>
                  <p>
                    {doc.solana_twitter_username ? '@' + doc.solana_twitter_username : doc.name}
                    {' ('}
                    {doc.stats.calculated_percent_change > 0 ? '+' : ''}
                    {doc.stats.calculated_percent_change + '%)'}
                  </p>
                  <p>
                    {'Today: ' +
                      doc.stats.floor_price +
                      ' SOL - ' +
                      'Yesterday: ' +
                      doc.stats.floor_price_yesterday +
                      ' SOL - '}{' '}
                    {doc.id}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ backgroundColor: '#FFFFFF' }}>
          <h1 className='font-bold text-xl text-center py-10 md:text-left lg:text-left md:px-6 lg:px-6'>
            Top 24h Movers by Ethereum
          </h1>

          <div style={{ paddingLeft: 24 }}>
            {listTwo.map((doc: any, index: any) => (
              <div
                key={doc.id}
                className='flex flex-row'
                style={{ alignItems: 'center', marginBottom: 24 }}
              >
                <div
                  className='flex flex-col'
                  style={{ marginRight: 28, fontWeight: '400', fontSize: 16 }}
                >
                  <p>#{index + 1}</p>
                </div>
                <img src={doc.image_url} width={60} height={60} style={{ marginRight: 24 }} />

                <div className='flex flex-col'>
                  <p>
                    {doc.twitter_username ? '@' + doc.twitter_username : doc.name}
                    {' ('}
                    {doc.stats.calculated_percent_change > 0 ? '+' : ''}
                    {doc.stats.calculated_percent_change + '%)'}
                  </p>
                  <p>
                    {'Today: ' +
                      doc.stats.floor_price +
                      ' ETH - ' +
                      'Yesterday: ' +
                      doc.stats.floor_price_yesterday +
                      ' ETH - '}{' '}
                    {doc.id}
                  </p>
                </div>
              </div>
            ))}
          </div>
            </div>*/}

        <ToastContainer limit={1} autoClose={3000} />
      </MainLayout>
    </React.Fragment>
  )
}

export default TestEnvironmentPage
